import { Suspense, FC } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { JsonLD } from './json-ld';
import { OG } from './og';
import { useUserDesc } from '../shared/use-user-desc';
import { Twitter } from './twitter';
import { $PageLevelTraffic } from 'shared/atoms';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { EPrivacyStatus } from 'shared/models';

export const UserFollowHeadInner: FC = () => {
  const description = useUserDesc();
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  const { t } = useTranslation();

  if (!user) {
    return null;
  }

  const keywords = t('keyword_default');
  const title = `${t('user_helmet_title')
    .replace('%1$s', user.nickName || '')
    .replace('%2$s', t('contribute'))}|Lemon8`;

  const fb_appid = 426786581540674;

  return (
    <Suspense>
      <title>{title}</title>
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="description" name="description" content={description} />
      {user.privacyStatus >= EPrivacyStatus.PrivateUser && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={canonicalUrl} />
      <JsonLD />
      <OG />
      <Twitter />
      <meta property="fb:app_id" content={String(fb_appid)} />
    </Suspense>
  );
};

export const UserFollowHead: FC = () => {
  return (
    <Suspense fallback={<></>}>
      <UserFollowHeadInner />
    </Suspense>
  );
};
